<template>
  <div>
    <router-view />
    <template v-if="!isStandalonePage">
      <GoTop />
      <WhatsApp/>
      <CookieConsent/>
    </template>
  </div>
</template>

<script>
import Preloader from './components/Layout/Preloader'
import GoTop from './components/Layout/GoTop'
import WhatsApp from './components/Layout/WhatsApp.vue'
import CookieConsent from './components/Layout/CookieConsent.vue'
export default {
  name: 'App',
  components: {
    Preloader,
    GoTop,
    WhatsApp,
    CookieConsent
  },
  data() {
    return {
      apiCalled: false // Add a flag to track whether API is called or not
    }
  },
  computed: {
    isStandalonePage() {
      // Hide global floating elements on standalone checkout/landing pages
      return this.$route && this.$route.name === 'PackageDetails';
    }
  },
  // watch: {
   
  //       if (newSlug) {
  //         this.getData2(newSlug);
  //       }
   
  // },

  async mounted() {
  // Defer Tawk.to script heavily (10 seconds) until after all major rendering is done
  setTimeout(() => {
    // Do not inject Chatbot if the user lands directly on a standalone checkout page
    if (this.isStandalonePage) return;

    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = "https://embed.tawk.to/620f8c201ffac05b1d7a894f/1fs6bmodt";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s0.parentNode.insertBefore(s1, s0);
  }, 10000);
},



  methods:{
  
  async getData() {
  
  await fetch('http://localhost:8979/api/sitemap')
     .then(response => response.text())
     .then(() => {
       // Handle the response as needed
       this.apiCalled = true; // Set the flag to true after API call
     })
     .catch(error => {
       console.error('Error fetching sitemap:', error);
     });
   }
},
}
</script>

<script setup>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute } from 'vue-router'

const canonicalUrl = ref('')

onMounted(() => {
  const route = useRoute()

  const updateCanonicalUrl = () => {
    canonicalUrl.value = 'https://www.meander.software' + route.path
  }

  const routeWatcher = watch(() => route.path, updateCanonicalUrl)

  updateCanonicalUrl()

  const canonicalLink = document.head.querySelector('link[rel="canonical"]')
  if (canonicalLink) {
    canonicalLink.setAttribute('href', canonicalUrl.value)
  } else {
    const newCanonicalLink = document.createElement('link')
    newCanonicalLink.rel = 'canonical'
    newCanonicalLink.href = canonicalUrl.value
    document.head.appendChild(newCanonicalLink)
  }

  onBeforeUnmount(() => {
    routeWatcher()
    updateCanonicalUrl()
  })
})
</script>

<style>
.razorpay-container {
  z-index: 2147483647 !important;
}
</style>
